module.exports = __webpack_public_path__ + "img/anthurium_langue_de_feu.f029f020.jpg";